import { Plugin, PluginKey } from '@tiptap/pm/state';
import type { Editor } from '@tiptap/vue-3';

export type FileHandlerPluginOptions = {
	key?: PluginKey;
	editor: Editor;
	allowedMimeTypes?: string[];
	onPaste: (editor: Editor, files: File[], pasteContent?: string) => void;
	onDrop: (editor: Editor, files: File[], pos: number) => void;
};

export const fileHandlerPlugin = ({
	key,
	editor,
	onPaste,
	onDrop,
	allowedMimeTypes,
}: FileHandlerPluginOptions) =>
	new Plugin({
		key: key || new PluginKey('imageFileHandler'),
		props: {
			handleDrop(view, event) {
				if (!onDrop) {
					return false;
				}

				const dataTransfer = event.dataTransfer;

				if (!dataTransfer || !dataTransfer.files.length) {
					return false;
				}

				const position = view.posAtCoords({
					left: event.clientX,
					top: event.clientY,
				});
				let files = Array.from(dataTransfer.files);

				if (allowedMimeTypes) {
					files = files.filter((file) =>
						allowedMimeTypes.includes(file.type)
					);
				}

				if (files.length === 0) {
					return false;
				}

				event.preventDefault();
				event.stopPropagation();
				onDrop(editor, files, position?.pos || 0);
				return true;
			},

			handlePaste(view, event) {
				if (!onPaste) {
					return false;
				}

				const clipboardData = event.clipboardData;

				if (!clipboardData || !clipboardData.files.length) {
					return false;
				}

				let files = Array.from(clipboardData.files);
				const htmlData = clipboardData.getData('text/html');

				if (allowedMimeTypes) {
					files = files.filter((file) =>
						allowedMimeTypes.includes(file.type)
					);
				}

				if (files.length === 0) {
					return false;
				}

				event.preventDefault();
				event.stopPropagation();
				onPaste(editor, files, htmlData);
				return htmlData.length === 0;
			},
		},
	});
